import { render, staticRenderFns } from "./CompanyIdDocuments.vue?vue&type=template&id=c014ab76&scoped=true&"
import script from "./CompanyIdDocuments.vue?vue&type=script&lang=js&"
export * from "./CompanyIdDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c014ab76",
  null
  
)

export default component.exports